import {ModelProvider, ModelProviderConfig} from "~/.shared/languageModel/ModelProviderConstants"
import {ModelName} from "~/generated/modelNames"

export type ModelConfig = {
  modelName: ModelName
  title: string
  apiName: string
  provider: ModelProvider
  isActive: boolean
  // Filter flags - stored in `models.details` JSON
  sota: boolean
  cheap: boolean
  reasoning: boolean
  fastInference: boolean
  // Boolean columns on `models`
  imageSupport: boolean
  videoSupport: boolean
  streamingSupport: boolean
}

/** Predicate: true when a model is active. Use with `.filter(isActiveModel)`. */
export const isActiveModel = (model: ModelConfig): boolean => model.isActive

/** Pure helper: look up a model config by name. Throws if not found. */
export const findModelConfig = (
  configs: ModelConfig[],
  modelName: ModelName | string
): ModelConfig => {
  const config = configs.find((c) => c.modelName === modelName)
  if (!config) throw new Error(`Unknown model: ${modelName}`)
  return config
}

/** Pure helper: look up a provider config for a given model name. */
export const findProviderConfig = (
  configs: ModelConfig[],
  providerConfigs: ModelProviderConfig[],
  modelName: ModelName | string
): ModelProviderConfig => {
  const config = findModelConfig(configs, modelName)
  const providerConfig = providerConfigs.find((p) => p.provider === config.provider)
  if (!providerConfig) {
    throw new Error(`Unknown provider for model ${modelName}: ${config.provider}`)
  }
  return providerConfig
}
